/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ClothesOuterTshirtIcon20Solid = forwardRef('ClothesOuterTshirtIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7 2a.5.5 0 0 1 .5.5 2.5 2.5 0 0 0 5 0A.5.5 0 0 1 13 2h.565A4 4 0 0 1 16.7 3.517l2.974 3.756a1 1 0 0 1-.106 1.356l-1.814 1.674a1 1 0 0 1-1.431-.076L16 9.857V15.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 4 15.5V9.857l-.324.37a1 1 0 0 1-1.43.076L.43 8.63a1 1 0 0 1-.106-1.356L3.3 3.517A4 4 0 0 1 6.435 2H7Z" })));
});
